import { createContext, useContext, useMemo } from 'react';
import { createEmptyHistoryState } from '@lexical/react/LexicalHistoryPlugin';

const Context = createContext({});

export function SharedHistoryContext({ children }) {
  const historyContext = useMemo(() => ({ historyState: createEmptyHistoryState() }), []);
  return <Context.Provider value={historyContext}>{children}</Context.Provider>;
}

export function useSharedHistoryContext() {
  return useContext(Context);
}
